// react
import { useContext } from 'react';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextIfrPlans } from '../../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableIfrPlans } from '../../../../../tables/cards/TableIfrPlans/TableIfrPlans';

// dialogs
import { DialogAddIfrPlan } from '../../../../../dialogs/DialogAddIfrPlan/DialogAddIfrPlan';

export const Plans = () => {
	// hooks
	const [searchParams, setSearchParams] = useSearchParams();

	// params
	const paramDialog = searchParams.get('dialog');

	// context
	const { paginationIfrPlans, ifrPlans, isLoadingIfrPlans, refetchIfrPlans } =
		useContext(ContextIfrPlans);

	// handlers
	const handleCloseDialog = () => {
		setSearchParams((params) => {
			params.delete('dialog');
			params.delete('dialogIfrPlan');
			return params;
		});
	};

	return (
		<>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TableIfrPlans
							isLoading={isLoadingIfrPlans}
							plans={ifrPlans}
							pagination={paginationIfrPlans}
						/>
					</Grid>
				</Grid>
			</Container>
			<DialogAddIfrPlan
				isOpen={paramDialog === 'addPlan'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchIfrPlans();
				}}
			/>
		</>
	);
};
